// import { Badge, Card, Col, Divider, Image, Row, Skeleton, Tag, Typography } from 'antd'
// import { KeyboardIcon, MouseIcon } from '../../../assets/icons'
// import { IconApp } from '../../../assets/icons/appIcon'
// import { IconTime } from '../../../assets/icons/timeIcon'
// import { IconDate } from '../../../assets/icons/dateIcon'

// export const ScreenShotComponent = (props) => {
//     const { screenshotsData = {}, token = '', loading = false } = props
//     const { Title, Text } = Typography

//     let data = Object.keys(screenshotsData?.data || {})
//     return (
//         <>
//             {/* <InfiniteScroll
//                 dataLength={
//                     state?.filteredNotesData?.length > 0
//                         ? state?.filteredNotesData?.length
//                         : 0
//                 }
//                 next={fetchMoreScreenShots}
//                 hasMore={isNext}
//                 style={{
//                     overflow: 'inherit',
//                 }}
//             > */}

//             {loading ? (
//                 <Row gutter={[25, 25]}>
//                     {[...Array(9)].map((_, index) => (
//                         <Col
//                             xs={24}
//                             sm={24}
//                             md={12}
//                             lg={12}
//                             xl={8}
//                             xxl={8}
//                             key={index}
//                         >
//                             <Card style={{ marginBottom: 10 }}>
//                                 <Skeleton.Image style={{ marginBottom: 10 }} active />
//                                 <Skeleton active paragraph={{ rows: 2 }} />
//                             </Card>
//                         </Col>
//                     ))}
//                 </Row>
//             ) : (
//                 <>
//                     {Object.keys(screenshotsData.data || {}).length === 0 ? (
//                         <div style={{ textAlign: "center", padding: "40px 0px" }}>

//                             <Text strong style={{ fontSize: 16, color: '#999', textAlign: "center" }}>
//                                 No screenshot available.
//                             </Text>
//                         </div>
//                     ) : data?.map((date) => {
//                         let subData = Object.keys(screenshotsData?.data[date])
//                         return subData.map((subTime) => (
//                             <>
//                                 <Row
//                                 // style={{
//                                 //     marginTop: '18px',
//                                 // }}
//                                 >
//                                     {/* <Col span={3}>
//                     <Row>

//                     </Row>
//                     <Row>

//                     </Row>
//                 </Col> */}
//                                     <Divider style={{ borderColor: "#8c8c8cc4" }}>
//                                         <Tag color="blue" style={{ margin: "0px" }}>

//                                             <div style={{ display: "flex", alignItems: "center" }}>
//                                                 {' '}
//                                                 <Text style={{ fontWeight: "700", display: "flex", alignItems: "center" }}> <IconDate width={20} style={{ marginRight: "2px" }} />{date}</Text>

//                                                 <Title style={{ fontWeight: "700", fontSize: "13px", display: "flex", alignItems: "center", marginTop: "0px", marginLeft: "10px" }}> <IconTime width={16} style={{ marginRight: "2px" }} />{subTime}</Title>
//                                             </div>
//                                         </Tag>
//                                     </Divider>
//                                     <Col span={24}>
//                                         <Image.PreviewGroup
//                                             preview={{
//                                                 onChange: () => { },
//                                             }}
//                                         >
//                                             <Row gutter={[30, 30]}>
//                                                 {screenshotsData?.data[date][subTime]
//                                                     ?.length > 0 &&
//                                                     screenshotsData?.data[date][
//                                                         subTime
//                                                     ].map((item) => (
//                                                         <Col
//                                                             xs={24}
//                                                             sm={24}
//                                                             md={12}
//                                                             lg={12}
//                                                             xl={8}
//                                                             xxl={8}
//                                                         >
//                                                             <Card
//                                                                 hoverable
//                                                                 bordered={false}
//                                                                 styles={{
//                                                                     body: {
//                                                                         padding: 10,
//                                                                     },
//                                                                 }}
//                                                                 style={{ boxShadow: " rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}
//                                                                 cover={
//                                                                     <Image
//                                                                         height={120}
//                                                                         src={
//                                                                             item?.url.includes(
//                                                                                 'https'
//                                                                             )
//                                                                                 ? item?.url
//                                                                                 : 'https://pms-bucket123.s3.amazonaws.com/locationImage_1717501529.jpg'
//                                                                         }
//                                                                         style={{
//                                                                             objectFit:
//                                                                                 'cover',
//                                                                             borderTopLeftRadius: "8px",
//                                                                             borderTopRightRadius: "8px"

//                                                                         }}
//                                                                         preview={
//                                                                             item?.url.includes(
//                                                                                 'https'
//                                                                             )
//                                                                                 ? true
//                                                                                 : false
//                                                                         }
//                                                                         onClick={() => {
//                                                                             if (
//                                                                                 !item?.url.includes(
//                                                                                     'https'
//                                                                                 )
//                                                                             ) {
//                                                                                 const parsedData =
//                                                                                     JSON.parse(
//                                                                                         item?.url
//                                                                                     )

//                                                                                 // Extract the values
//                                                                                 const lat =
//                                                                                     parsedData?.lat
//                                                                                 const lng =
//                                                                                     parsedData?.long // changed 'long' to 'lng' to avoid conflict with reserved keyword

//                                                                                 const url = `https://www.google.com/maps?q=${lat},${lng}`
//                                                                                 // Open the URL in a new tab
//                                                                                 window.open(
//                                                                                     url,
//                                                                                     '_blank'
//                                                                                 )
//                                                                             }
//                                                                         }}
//                                                                     />
//                                                                 }
//                                                             >
//                                                                 <Row
//                                                                     align={'middle'}
//                                                                     style={{
//                                                                         columnGap:
//                                                                             '8px',
//                                                                     }}
//                                                                 >
//                                                                     <Title
//                                                                         level={5}
//                                                                         style={{
//                                                                             margin: 0,
//                                                                         }}
//                                                                     >
//                                                                         {new Date(
//                                                                             item?.createdAt
//                                                                         ).toLocaleString(
//                                                                             'default',
//                                                                             {
//                                                                                 hour: 'numeric',
//                                                                                 minute: '2-digit',
//                                                                             }
//                                                                         )}
//                                                                     </Title>
//                                                                     {!item?.url.includes(
//                                                                         'https'
//                                                                     ) && (
//                                                                             <Badge
//                                                                                 count={`${JSON.parse(
//                                                                                     item?.url
//                                                                                 )?.type
//                                                                                     } Time`}
//                                                                                 color={
//                                                                                     JSON.parse(
//                                                                                         item?.url
//                                                                                     )
//                                                                                         ?.type ===
//                                                                                         'start'
//                                                                                         ? 'hsla(155, 54%, 46%, 0.16)'
//                                                                                         : 'hsla(11, 100%, 59%, 0.16)'
//                                                                                 }
//                                                                                 style={{
//                                                                                     minWidth:
//                                                                                         '30px',
//                                                                                     cursor: 'auto',
//                                                                                     borderRadius:
//                                                                                         '6px',
//                                                                                     display:
//                                                                                         'flex',
//                                                                                     alignItems:
//                                                                                         'center',
//                                                                                     color:
//                                                                                         JSON.parse(
//                                                                                             item?.url
//                                                                                         )
//                                                                                             ?.type ===
//                                                                                             'start'
//                                                                                             ? token
//                                                                                                 .colorPalette
//                                                                                                 .iconColor
//                                                                                                 .tertiary
//                                                                                             : token
//                                                                                                 .colorPalette
//                                                                                                 .iconColor
//                                                                                                 .quaternary,
//                                                                                     padding:
//                                                                                         '12px 8px',
//                                                                                     fontWeight: 700,
//                                                                                     textTransform:
//                                                                                         'uppercase',
//                                                                                 }}
//                                                                             />
//                                                                         )}
//                                                                 </Row>
//                                                                 <Row
//                                                                     style={{
//                                                                         width: '100%',
//                                                                     }}
//                                                                     justify={
//                                                                         'space-between'
//                                                                     }
//                                                                 >
//                                                                     {item?.url.includes(
//                                                                         'https'
//                                                                     ) ? (
//                                                                         <Row>
//                                                                             <div
//                                                                                 style={{
//                                                                                     height: '16px',
//                                                                                     width: '16px',
//                                                                                     marginRight:
//                                                                                         '10px',
//                                                                                 }}
//                                                                             >
//                                                                                 <KeyboardIcon />
//                                                                             </div>
//                                                                             <span>
//                                                                                 Keystrokes
//                                                                                 / min
//                                                                                 &nbsp;
//                                                                             </span>
//                                                                         </Row>
//                                                                     ) : (
//                                                                         <span>
//                                                                             Latitude
//                                                                             &nbsp;
//                                                                         </span>
//                                                                     )}

//                                                                     <span
//                                                                         style={{
//                                                                             fontWeight: 600,
//                                                                         }}
//                                                                     >
//                                                                         {item?.url.includes(
//                                                                             'https'
//                                                                         )
//                                                                             ? item?.total_mouse_movements
//                                                                                 ? parseInt(
//                                                                                     item?.total_keypresses
//                                                                                 )
//                                                                                 : 0
//                                                                             : JSON.parse(
//                                                                                 item?.url
//                                                                             )?.lat}
//                                                                     </span>
//                                                                 </Row>
//                                                                 <Row
//                                                                     style={{
//                                                                         width: '100%',
//                                                                     }}
//                                                                     justify={
//                                                                         'space-between'
//                                                                     }
//                                                                 >
//                                                                     {item?.url.includes(
//                                                                         'https'
//                                                                     ) ? (
//                                                                         <Row>
//                                                                             <div
//                                                                                 style={{
//                                                                                     height: '16px',
//                                                                                     width: '16px',
//                                                                                     marginRight:
//                                                                                         '10px',
//                                                                                 }}
//                                                                             >
//                                                                                 <MouseIcon />
//                                                                             </div>
//                                                                             <span>
//                                                                                 Mouse
//                                                                                 moments
//                                                                                 / min
//                                                                                 &nbsp;
//                                                                             </span>
//                                                                         </Row>
//                                                                     ) : (
//                                                                         <span>
//                                                                             Longitude
//                                                                             &nbsp;
//                                                                         </span>
//                                                                     )}
//                                                                     <span
//                                                                         style={{
//                                                                             fontWeight: 600,
//                                                                         }}
//                                                                     >
//                                                                         {item?.url.includes(
//                                                                             'https'
//                                                                         )
//                                                                             ? item?.total_mouse_movements
//                                                                                 ? parseInt(
//                                                                                     item?.total_mouse_movements
//                                                                                 )
//                                                                                 : 0
//                                                                             : JSON.parse(
//                                                                                 item?.url
//                                                                             )?.long}
//                                                                     </span>
//                                                                 </Row>
//                                                                 <Row
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         marginTop:
//                                                                             '10px',
//                                                                     }}
//                                                                     justify={
//                                                                         'space-between'
//                                                                     }
//                                                                 >
//                                                                     <Col span={24}>
//                                                                         <Divider
//                                                                             dashed
//                                                                             style={{
//                                                                                 margin: '8px 0',
//                                                                             }}
//                                                                         />
//                                                                         <Row style={{ alignItems: "center" }}>
//                                                                             <div
//                                                                                 style={{
//                                                                                     // height: '16px',
//                                                                                     // width: '16px',
//                                                                                     marginRight:
//                                                                                         '10px',
//                                                                                 }}
//                                                                             >
//                                                                                 <IconApp width={18} />
//                                                                             </div>
//                                                                             <Text
//                                                                                 strong
//                                                                                 // type="success"
//                                                                                 style={{
//                                                                                     marginLeft: 0,
//                                                                                 }}
//                                                                             >
//                                                                                 {item
//                                                                                     ?.activeWindow
//                                                                                     ?.owner
//                                                                                     ?.name ||
//                                                                                     'Unknown App'}
//                                                                             </Text>
//                                                                         </Row>
//                                                                         {/* <Row>
//                                                         <Text
//                                                             style={{
//                                                                 fontSize:
//                                                                     '12px',
//                                                             }}
//                                                         >
//                                                             {item
//                                                                 ?.activeWindow
//                                                                 ?.title ||
//                                                                 'No Title'}
//                                                         </Text>
//                                                     </Row> */}
//                                                                     </Col>
//                                                                 </Row>
//                                                             </Card>
//                                                         </Col>
//                                                     ))}
//                                             </Row>
//                                         </Image.PreviewGroup>
//                                     </Col>
//                                 </Row >
//                                 {/* <Divider /> */}
//                             </>
//                         ))
//                     })}

//                 </>
//             )
//             }
//             {/* </InfiniteScroll> */}
//         </>
//     )
// }



import React from 'react';
import { Badge, Card, Col, Divider, Image, Row, Skeleton, Spin, Tag, Typography } from 'antd';
import { KeyboardIcon, MouseIcon } from '../../../assets/icons'
import { IconApp } from '../../../assets/icons/appIcon'
import { IconTime } from '../../../assets/icons/timeIcon'
import { IconDate } from '../../../assets/icons/dateIcon'
import InfiniteScroll from 'react-infinite-scroll-component'
import dayjs from 'dayjs';

const { Text, Title } = Typography;

function groupScreenshotsByDateAndHour(data = []) {
    const grouped = {};

    data.forEach((item) => {
        const createdAt = dayjs(item.createdAt);
        const date = createdAt.format('DD MMM YYYY');
        const hour = createdAt.format('hh A');

        if (!grouped[date]) grouped[date] = {};
        if (!grouped[date][hour]) grouped[date][hour] = [];

        grouped[date][hour].push(item);
    });

    return grouped;
}

export const ScreenShotComponent = ({ screenshotsData, loading, token, onLoadMore }) => {
    if (loading && (!screenshotsData?.data || screenshotsData?.data?.length === 0)) {
        return (
            <Row gutter={[25, 25]}>
                {[...Array(9)].map((_, index) => (
                    <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        xl={8}
                        xxl={8}
                        key={index}
                    >
                        <Card style={{ marginBottom: 10 }}>
                            <Skeleton.Image style={{ marginBottom: 10 }} active />
                            <Skeleton active paragraph={{ rows: 2 }} />
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    }
    const groupedScreenshots = groupScreenshotsByDateAndHour(screenshotsData?.data || []);
    const dates = Object.keys(groupedScreenshots || {});

    if (!dates.length) {
        return (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <Text strong style={{ fontSize: 16, color: '#999' }}>
                    No screenshots available.
                </Text>
            </div>
        );
    }

    return (
        <>
            <InfiniteScroll
                scrollableTarget="scrollableDiv" // 🔥 important!
                dataLength={screenshotsData?.data?.length || 0}
                next={onLoadMore}
                hasMore={screenshotsData?.isNext}
                loader={
                    <div style={{ textAlign: 'center', padding: 20 }}>
                        <Spin tip="Loading more..." />
                    </div>
                }
            // endMessage={
            //     <div style={{ textAlign: 'center', padding: 20 }}>
            //         <Text type="secondary">No more screenshots to load.</Text>
            //     </div>
            // }
            >

                {dates.map((date, index) => {
                    const hours = Object.keys(groupedScreenshots[date] || {});
                    return hours.map((hour) => (
                        <React.Fragment key={`${index}`}>
                            <Row>
                                <Divider orientation="left" style={{ borderColor: '#8c8c8cc4' }}>
                                    <Tag color="blue" style={{ margin: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Title level={5} style={{ fontWeight: 700, display: 'flex', alignItems: 'center' }}>
                                                <IconDate width={20} style={{ marginRight: '4px' }} />
                                                {date}
                                            </Title>
                                            <Title
                                                level={5}
                                                style={{
                                                    fontWeight: 700,
                                                    margin: 0,
                                                    marginLeft: 12,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <IconTime width={16} style={{ marginRight: '4px' }} />
                                                {hour}
                                            </Title>
                                        </div>
                                    </Tag>
                                </Divider>

                                <Col span={24}>
                                    <Image.PreviewGroup preview={{ onChange: () => { } }}>
                                        <Row gutter={[30, 30]}>
                                            {groupedScreenshots[date][hour]?.map((item) => (
                                                <Col
                                                    key={item._id}
                                                    xs={24}
                                                    sm={24}
                                                    md={12}
                                                    lg={12}
                                                    xl={8}
                                                    xxl={8}
                                                >
                                                    <Card
                                                        hoverable
                                                        bordered={false}
                                                        styles={{
                                                            body: {
                                                                padding: 10,
                                                            },
                                                        }}
                                                        style={{ boxShadow: " rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}
                                                        cover={
                                                            <Image
                                                                height={120}
                                                                src={
                                                                    item?.url.includes(
                                                                        'https'
                                                                    )
                                                                        ? item?.url
                                                                        : 'https://pms-bucket123.s3.amazonaws.com/locationImage_1717501529.jpg'
                                                                }
                                                                style={{
                                                                    objectFit:
                                                                        'cover',
                                                                    borderTopLeftRadius: "8px",
                                                                    borderTopRightRadius: "8px"

                                                                }}
                                                                preview={
                                                                    item?.url.includes(
                                                                        'https'
                                                                    )
                                                                        ? true
                                                                        : false
                                                                }
                                                                onClick={() => {
                                                                    if (
                                                                        !item?.url.includes(
                                                                            'https'
                                                                        )
                                                                    ) {
                                                                        const parsedData =
                                                                            JSON.parse(
                                                                                item?.url
                                                                            )

                                                                        // Extract the values
                                                                        const lat =
                                                                            parsedData?.lat
                                                                        const lng =
                                                                            parsedData?.long // changed 'long' to 'lng' to avoid conflict with reserved keyword

                                                                        const url = `https://www.google.com/maps?q=${lat},${lng}`
                                                                        // Open the URL in a new tab
                                                                        window.open(
                                                                            url,
                                                                            '_blank'
                                                                        )
                                                                    }
                                                                }}
                                                            />
                                                        }
                                                    >
                                                        <Row
                                                            align={'middle'}
                                                            style={{
                                                                columnGap:
                                                                    '8px',
                                                            }}
                                                        >
                                                            <Title
                                                                level={5}
                                                                style={{
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                {new Date(
                                                                    item?.createdAt
                                                                ).toLocaleString(
                                                                    'default',
                                                                    {
                                                                        hour: 'numeric',
                                                                        minute: '2-digit',
                                                                    }
                                                                )}
                                                            </Title>
                                                            {!item?.url.includes(
                                                                'https'
                                                            ) && (
                                                                    <Badge
                                                                        count={`${JSON.parse(
                                                                            item?.url
                                                                        )?.type
                                                                            } Time`}
                                                                        color={
                                                                            JSON.parse(
                                                                                item?.url
                                                                            )
                                                                                ?.type ===
                                                                                'start'
                                                                                ? 'hsla(155, 54%, 46%, 0.16)'
                                                                                : 'hsla(11, 100%, 59%, 0.16)'
                                                                        }
                                                                        style={{
                                                                            minWidth:
                                                                                '30px',
                                                                            cursor: 'auto',
                                                                            borderRadius:
                                                                                '6px',
                                                                            display:
                                                                                'flex',
                                                                            alignItems:
                                                                                'center',
                                                                            color:
                                                                                JSON.parse(
                                                                                    item?.url
                                                                                )
                                                                                    ?.type ===
                                                                                    'start'
                                                                                    ? token
                                                                                        .colorPalette
                                                                                        .iconColor
                                                                                        .tertiary
                                                                                    : token
                                                                                        .colorPalette
                                                                                        .iconColor
                                                                                        .quaternary,
                                                                            padding:
                                                                                '12px 8px',
                                                                            fontWeight: 700,
                                                                            textTransform:
                                                                                'uppercase',
                                                                        }}
                                                                    />
                                                                )}
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            {item?.url.includes(
                                                                'https'
                                                            ) ? (
                                                                <Row>
                                                                    <div
                                                                        style={{
                                                                            height: '16px',
                                                                            width: '16px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        <KeyboardIcon />
                                                                    </div>
                                                                    <span>
                                                                        Keystrokes
                                                                        / min
                                                                        &nbsp;
                                                                    </span>
                                                                </Row>
                                                            ) : (
                                                                <span>
                                                                    Latitude
                                                                    &nbsp;
                                                                </span>
                                                            )}

                                                            <span
                                                                style={{
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {item?.url.includes(
                                                                    'https'
                                                                )
                                                                    ? item?.total_mouse_movements
                                                                        ? parseInt(
                                                                            item?.total_keypresses
                                                                        )
                                                                        : 0
                                                                    : JSON.parse(
                                                                        item?.url
                                                                    )?.lat}
                                                            </span>
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            {item?.url.includes(
                                                                'https'
                                                            ) ? (
                                                                <Row>
                                                                    <div
                                                                        style={{
                                                                            height: '16px',
                                                                            width: '16px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        <MouseIcon />
                                                                    </div>
                                                                    <span>
                                                                        Mouse
                                                                        moments
                                                                        / min
                                                                        &nbsp;
                                                                    </span>
                                                                </Row>
                                                            ) : (
                                                                <span>
                                                                    Longitude
                                                                    &nbsp;
                                                                </span>
                                                            )}
                                                            <span
                                                                style={{
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {item?.url.includes(
                                                                    'https'
                                                                )
                                                                    ? item?.total_mouse_movements
                                                                        ? parseInt(
                                                                            item?.total_mouse_movements
                                                                        )
                                                                        : 0
                                                                    : JSON.parse(
                                                                        item?.url
                                                                    )?.long}
                                                            </span>
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            <Col span={24}>
                                                                <Divider
                                                                    dashed
                                                                    style={{
                                                                        margin: '8px 0',
                                                                    }}
                                                                />
                                                                <Row style={{ alignItems: "center" }}>
                                                                    <div
                                                                        style={{
                                                                            // height: '16px',
                                                                            // width: '16px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        <IconApp width={18} />
                                                                    </div>
                                                                    <Text
                                                                        strong
                                                                        // type="success"
                                                                        style={{
                                                                            marginLeft: 0,
                                                                        }}
                                                                    >
                                                                        {item
                                                                            ?.activeWindow
                                                                            ?.owner
                                                                            ?.name ||
                                                                            'Unknown App'}
                                                                    </Text>
                                                                </Row>
                                                                {/* <Row>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            {item
                                                                ?.activeWindow
                                                                ?.title ||
                                                                'No Title'}
                                                        </Text>
                                                    </Row> */}
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Image.PreviewGroup>
                                </Col>
                            </Row>
                        </React.Fragment>
                    ));
                })}
            </InfiniteScroll>
        </>
    );
};

